import { CommonResponse, TargetMenu } from 'models';
import axiosClient from 'utils/axiosClient';

const BASE_URL = '/shabu-sukiyaki';

const buildUrl = (type: string) => {
  const queryString = new URLSearchParams({ type }).toString();
  return queryString ? `${BASE_URL}?${queryString}` : BASE_URL;
};

export const shabuSukiyakiService = {
  getList(type: string): Promise<CommonResponse<TargetMenu[]>> {
    return axiosClient.get(buildUrl(type));
  },
  createOrUpdateDashiGenres(payload: number[], type: string): Promise<CommonResponse<any[]>> {
    return axiosClient.post(buildUrl(type), payload);
  },
  addMenuIds(payload: number[], type: string): Promise<CommonResponse<any[]>> {
    return axiosClient.post(buildUrl(type), payload);
  },
  deleteMenuIds(payload: number[], type: string): Promise<CommonResponse<any[]>> {
    return axiosClient.delete(buildUrl(type), { data: payload });
  },
};
